<template>
    <div>
        <p class="pause-question" v-html="handlingForCountry"></p>
         <p v-if="isUSA"></p>
        <form method="post" class="my-flowers">
            <div class="input__radio my-flowers" v-for="(item, index) in this.flowersrestart" :key="index">
                <input
                    class="input__radio-item"
                    :id="index"
                    v-model="val"
                    type="radio"
                    :option="item.option"
                    :value="item.option"/>
                <label
                    :for="index"
                    class="input__radio-label my-flowers--label"
                    v-text="item.label"
                    :label="item.label">
                </label>
            </div>
        </form>
        <button @click.prevent="pauseWithFlowers" class="btn btn--primary btn--full-width restart-date--confirm mt-4 mb-4">
            <span v-if="!processing" v-text="$t('PAUSE_DELIVERIES_NO_THANKS_RESTART')"/>
            <i v-else class="btn__loading-icon fa-spin"/>
        </button>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import * as AddressConsts from '@/constants/Address';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import SubscriptionService from '@/services/subscriptions/SubscriptionService';
import i18n from '@/i18n';

let subscriptionService = new SubscriptionService();

export default {
    name: 'FlowersStep',
    props: {
        subscriptionId: {
            required: true,
            type: Number,
        },
        pauseSurveyAnswer: {
            type: Object,
            required: true,
        },
        value: {
            default: null,
            type: String,
        },
        label: {
            default: null,
            type: String,
        },
    },
    data() {
        return {
            stageId: 'flowers',
            isNextStepClicked: false,
            errorHandler: new ErrorResponseHandler(),
            processing: false,
            val: null,
            flowersrestart: [
                {
                    label: i18n.t('FLOWER_QUALITY'),
                    option: AddressConsts.TYPE_QUALITY,
                },
                {
                    label: i18n.t('FLOWER_VALUE'),
                    option: AddressConsts.TYPE_VALUE,
                },
                {
                    label: i18n.t('FLOWER_STYLE'),
                    option: AddressConsts.TYPE_STYLE,
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            isUSA: 'localisation/isUSA',
        }),
        updatedSteps() {
            const currentStepIndex = this.pauseSurveyAnswer.nextSteps.indexOf(this.stageId);
            return this.pauseSurveyAnswer.nextSteps.slice(currentStepIndex + 1);
        },
        handlingForCountry() {
            return this.isUSA ? this.getTitleForHouseRenovation : this.$t('PAUSE_DELIVERIES_RESTART_DATE_QUESTION');
        },
    },
    methods: {
        pauseWithFlowers() {
            if (this.val) {
                this.processing = true;
            }
            subscriptionService.pauseSubscription({ subscriptionId: this.subscriptionId, reason: this.pauseSurveyAnswer.label, feedback: null, flowersStart: this.val })
                .then(() => {
                    this.$emit('deliveries-paused');
                    this.processing = false;
                })
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
        closePauseDeliveries() {
            this.stage = 1;
            this.$emit('closed');
        },

        nextStep() {
            this.isNextStepClicked = true;
            this.$emit('input', this.updatedSteps);
        },
    },
    watch: {
        val(value) {
            this.val = value;
        },
        value: {
            immediate: true,
            handler(value) {
                this.val = value;
            },
        },
    },
};
</script>
